import DialogPanel from './DialogPanel';

export default DialogPanel;
